import { Injectable } from '@angular/core';
import { ArcElement, Chart, DoughnutController, Legend, Title, Tooltip } from 'chart.js';

let initialized = false;

@Injectable({
    providedIn: 'root'
})
export class ChartJSInitializationService {
    public initializeChartJS(): void {
        if (!initialized) {
            Chart.defaults.font.family = "'Source Sans 3'";

            Chart.register(
                ArcElement,
                DoughnutController,
                Legend,
                Title,
                Tooltip,
                
            );

            initialized = true;
        }
    }
}
